import type { OrderType, PageInfo, SortingConfig } from "~/types/services";

export type SearchFilterOptions = {
  value: number | string;
  title: string;
  props: Record<string, string>;
}[];
type SearchFilter = {
  followersMin?: number;
  followersMax?: number;
  erMin?: number | null;
  erMax?: number | null;
  page_groups?: number[];
  biography?: string;
  categories?: number[];
  genderTypes?: string[];
  locations?: string[];
};
type FilterConfigs = {
  categoryOptions?: SearchFilterOptions;
  genderOptions?: SearchFilterOptions;
  followerMax?: number;
  followerMin?: number;
  erMin?: number;
  erMax?: number;
  pageGroupOptions?: SearchFilterOptions;
  locationOptions?: SearchFilterOptions;
};
export type SearchState = {
  search: string;
  filters: SearchFilter;
  pages: PageInfo[];
  filterConfigs: FilterConfigs;
  sortingConfigs: SortingConfig;
  ordering: string;
  orderType: OrderType;
  pagesCount: number;
  pageNumber: number;
  resetSearch: boolean;
};

export type SearchStateValue<K extends keyof SearchState> = SearchState[K];

export const useSearchStore = defineStore("searchStore", {
  state: (): SearchState => {
    return {
      search: "",
      ordering: "",
      orderType: "DESC",
      filters: {},
      pages: [],
      filterConfigs: {},
      sortingConfigs: {},
      pagesCount: 0,
      pageNumber: 1,
      resetSearch: true,
    };
  },
  getters: {
    filterCounts(): number {
      const filterCounts = Object.keys(this.filters).filter((key) => {
        const item = this.filters[key as keyof typeof this.filters];
        const isExist =
          item && typeof item === "object" && "length" in item
            ? !!item.length
            : !!item;
        return !["followersMin"].includes(key) && isExist;
      }).length;
      const hasSearch = this.search?.length;
      return hasSearch ? filterCounts + 1 : filterCounts;
    },

    hasFilterConfigs(): boolean {
      return (
        "categoryOptions" in this.filterConfigs &&
        "genderOptions" in this.filterConfigs &&
        "followerMax" in this.filterConfigs
      );
    },
    hasSortingConfigs(): boolean {
      return !!Object.keys(this.sortingConfigs).length;
    },
  },
  actions: {
    setPages(pages: PageInfo[]) {
      this.pages = pages;
    },
    clearStore() {
      this.search = "";
      this.filters = {};
      this.pages = [];
      this.pagesCount = 0;
      this.pageNumber = 1;
      this.resetSearch = true;
      this.ordering = "";
      this.orderType = "ASC";
    },
  },
});
